// GitHub-style tooltips for every element with a title: the native tooltip is replaced
// (title moves to data-tooltip on first hover), one shared popover shows the text above
// the element, or below when there is no room. aria-labels stay for screen readers.
const DELAY_MS = 400
const GAP = 6

let tip
let target = null
let timer = null

function element() {
  if (!tip) {
    tip = document.createElement('div')
    tip.className = 'tooltip'
    tip.popover = 'manual'
    tip.setAttribute('role', 'tooltip')
    document.body.append(tip)
  }
  return tip
}

/** The element's box; one with display: contents has none, then the box around its content. */
function boxOf(el) {
  const box = el.getBoundingClientRect()
  if (box.width || box.height) return box
  const range = document.createRange()
  range.selectNodeContents(el)
  return range.getBoundingClientRect()
}

function place(el) {
  const box = boxOf(el)
  const tooltip = element()
  tooltip.textContent = el.dataset.tooltip
  tooltip.showPopover()
  const { width, height } = tooltip.getBoundingClientRect()
  const above = box.top - GAP - height >= 4
  const top = above ? box.top - GAP - height : box.bottom + GAP
  const left = Math.min(
    Math.max(4, box.left + box.width / 2 - width / 2),
    innerWidth - width - 4
  )
  Object.assign(tooltip.style, { top: `${top}px`, left: `${left}px` })
  tooltip.dataset.side = above ? 'top' : 'bottom'
}

function hide() {
  clearTimeout(timer)
  target = null
  if (tip?.matches(':popover-open')) tip.hidePopover()
}

function over(evt) {
  const el = evt.target.closest?.('[title], [data-tooltip]')
  if (el === target) return
  hide()
  if (!el) return
  if (el.hasAttribute('title')) {
    const text = el.getAttribute('title')
    el.removeAttribute('title') // keeps the browser's own tooltip away
    if (!text) return
    el.dataset.tooltip = text
  }
  if (!el.dataset.tooltip) return
  target = el
  timer = setTimeout(
    () => target === el && el.isConnected && place(el),
    DELAY_MS
  )
}

export function initTooltips() {
  document.addEventListener('pointerover', over, true)
  document.addEventListener('pointerdown', hide, true)
  document.addEventListener('keydown', hide, true)
  document.addEventListener('scroll', hide, true)
  document.addEventListener('pointerleave', hide)
}
